import LoadingPage from "views/Base/LoadingPage";
import SettingsOutlet from "./SettingsOutlet";
import { Suspense } from "react";
import { Layout } from "antd";

export default function Settings(): React.ReactElement {
  return (
    <Layout className="layout-card">
      <Suspense fallback={<LoadingPage />}>
        <SettingsOutlet />
      </Suspense>
    </Layout>
  );
}
